<div class="p-6">
    <div>
        <button tabindex="-1" mat-icon-button class="close-button mat-modal-close-btn float-right width-20"
            (click)="Cancel()">
            <mat-icon class="close-icon text-dark_gray">close</mat-icon>
        </button>
        <h2>Internal Communication</h2>
    </div>
    <form [formGroup]="formGroup">
        <div class="mb-4">
            <label for="titleInput" style="display: block; font-weight: 500; margin-bottom: 4px;">
                Title <span style="color: red;">*</span>
            </label>
            <app-input [required]="true" formControlName="title"></app-input>
        </div>
        <div class="mb-4">
            <label for="messageInput" style="display: block; font-weight: 500; margin-bottom: 4px;">
                Message <span style="color: red;">*</span>
            </label>
            <textarea required class="w-full border border-solid border-dark_gray outline-none" matInput
                id="messageInput" placeholder="Message Here" rows="5" formControlName="message" required></textarea>
            <mat-error *ngIf="formGroup.get('message')?.hasError('required') && formGroup.get('message')?.touched"
                class="error-message">
                Required.
            </mat-error>
        </div>
        <div style="margin-bottom: 16px;">
            <label for="messageType" style="display: block; font-weight: 500; margin-bottom: 4px;">
                Select the message type
            </label>
            <thera-dropdown [options]="messageType" [formGroup]="formGroup" (optionSelected)="messageType"
                [placeholder]="'General'" controlName="messageTypeControl">
            </thera-dropdown>
        </div>
        <div class="dialog-actions" style="text-align: right;">
            <thera-button class="mr-3" (clicked)="resetForm()" [config]="{
                text: 'Reset',
                variant: buttonVariant.PRIMARY
            }"></thera-button>
            <thera-button class="mr-3" (clicked)="SendasDraft()" [config]="{
                    text: 'Save as Draft',
                    variant: buttonVariant.PRIMARY
                }"></thera-button>
            <thera-button (clicked)="Send()" [config]="{
                    text: 'Send',
                    variant: buttonVariant.PRIMARY
                }"></thera-button>
        </div>
    </form>
</div>